__turbopack_context__.v({
  "container": "Input-module__TUkKBG__container",
  "container__fullWidth": "Input-module__TUkKBG__container__fullWidth",
  "input": "Input-module__TUkKBG__input",
  "inputTextPrefix": "Input-module__TUkKBG__inputTextPrefix",
  "inputWrapper": "Input-module__TUkKBG__inputWrapper",
  "input__error": "Input-module__TUkKBG__input__error",
  "input__fullWidth": "Input-module__TUkKBG__input__fullWidth",
  "input__search": "Input-module__TUkKBG__input__search",
  "input__withInputText": "Input-module__TUkKBG__input__withInputText",
  "input__withLeftIcon": "Input-module__TUkKBG__input__withLeftIcon",
  "input__withRightIcon": "Input-module__TUkKBG__input__withRightIcon",
  "label": "Input-module__TUkKBG__label",
  "leftIcon": "Input-module__TUkKBG__leftIcon",
  "message": "Input-module__TUkKBG__message",
  "message__error": "Input-module__TUkKBG__message__error",
  "rightIcon": "Input-module__TUkKBG__rightIcon",
});
